import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { TooltipProvider } from '@trellis/roots/tooltip'
import { ThemeProvider } from 'next-themes'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'
import './sentry.js'
import { TenantProvider } from './components/TenantProvider.js'
import { queryClient } from './lib/query-client.js'
import { registerServiceWorker } from './lib/register-service-worker.js'
import { router } from './router.js'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

registerServiceWorker()

createRoot(root, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload the page.</p>}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <QueryClientProvider client={queryClient}>
          <TenantProvider>
            <TooltipProvider>
              <RouterProvider router={router} />
            </TooltipProvider>
          </TenantProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
